import {Form as AntForm} from 'antd';
import InputMask from 'react-input-mask';
import style from './style';
import { CNPJ_MASK, CNPJ_FORMAT_CHARS } from '@/@core/utils/cnpj.utils';

interface IInputCnpj {
    name: string;
    label?: string;
    placeholder?: string;
    required?: boolean;
}

const InputCnpj = (props: IInputCnpj) => {
    return (
        <AntForm.Item
            name={props?.name ?? 'cnpj'}
            label={props?.label ?? 'CNPJ'}
            rules={[{required: props.required}]}
        >
            <InputMask
                mask={CNPJ_MASK}
                formatChars={CNPJ_FORMAT_CHARS}
                maskChar={null}
                style={style.cnpj}
                data-testid="input-cnpj"
                placeholder={props?.placeholder ?? 'CNPJ'}
            />
        </AntForm.Item>
    );
};

export {InputCnpj};
